import { render, staticRenderFns } from "./InternationalAddressField.vue?vue&type=template&id=214a2eb0"
import script from "./InternationalAddressField.vue?vue&type=script&lang=js"
export * from "./InternationalAddressField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports